import LeftBare from "./LeftBare";
export default LeftBare;
